import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";

export const GOOGLE_SIGNUP_KEY = "findo_google_signup";

// Handles the Emergent Google Auth redirect (`#session_id=...`). Existing member → logged in.
// New email → NO account: the verified identity is kept for the signup form (form → plan → payment).
export default function GoogleAuthWatcher() {
  const { t } = useLang();
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const m = /session_id=([^&]+)/.exec(window.location.hash || "");
    if (!m) return;
    done.current = true;
    (async () => {
      try {
        const res = await loginWithGoogleSession(decodeURIComponent(m[1]));
        window.history.replaceState(null, "", window.location.pathname);
        if (res.mode === "signup") {
          sessionStorage.setItem(GOOGLE_SIGNUP_KEY, JSON.stringify({ google_token: res.google_token, email: res.email, name: res.name }));
          navigate("/auth/register?google=1", { replace: true });
          return;
        }
        toast.success(t("hc.signedInWithGoogle"));
        navigate("/b2b/registry", { replace: true });
      } catch (e) {
        toast.error(e.message || t("hc.googleLoginFailed"));
        window.history.replaceState(null, "", window.location.pathname);
      }
    })();
  }, [loginWithGoogleSession, navigate, t]);

  return null;
}
